import React, { FC, useEffect, useState } from 'react';
import TextField, { TextFieldPropsType, TextFieldValueType } from '../TextField';
import { useDebounce } from 'src/utils/debounce';

const TextFieldDebounced: FC<TextFieldPropsType> = (props) => {
    const { value, error, onChange } = props;

    const [inputValue, setInputValue] = useState<TextFieldValueType>(undefined);
    const [inputError, setInputError] = useState<boolean | undefined>(undefined);

    const debouncedInputValue = useDebounce(inputValue, 300);
    // change prop after debounce
    useEffect(() => {
        if (onChange && inputValue !== undefined) {
            onChange(inputValue, !!inputError);
        }
    }, [debouncedInputValue]);

    // clear data after is prop set
    useEffect(() => {
        if (onChange && inputValue === value) {
            setInputValue(undefined);
            setInputError(undefined);
        }
    }, [value]);

    // change state values and clear data
    const handleChange = (newValue: TextFieldValueType, newError: boolean) => {
        if (onChange && newValue === undefined) {
            onChange(newValue, newError);
        }
        setInputValue(newValue);
        setInputError(newError);
    };

    return (
        <TextField
            {...props}
            onChange={handleChange}
            value={inputValue !== undefined ? inputValue : value}
            error={inputError !== undefined ? inputError : error}
        />
    );
};

export default TextFieldDebounced;
